"use client";

import { useCallback } from "react";
import { parseAsBoolean, useQueryState } from "nuqs";

const pastSearchesParser = parseAsBoolean.withDefault(false);

export function useRecentSearches() {
  const [open, setOpen] = useQueryState("pastSearches", pastSearchesParser);

  const openPastSearches = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const closePastSearches = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return {
    pastSearchesOpen: open,
    setPastSearchesOpen: setOpen,
    openPastSearches,
    closePastSearches,
  };
}
